/**
 * Enter here the user flows and custom policies for your B2C application
 * To learn more about user flows, visit: https://docs.microsoft.com/en-us/azure/active-directory-b2c/user-flow-overview
 * To learn more about custom policies, visit: https://docs.microsoft.com/en-us/azure/active-directory-b2c/custom-policy-overview
 */
let Policies = {
    clientId: process.env.REACT_APP_AZURE_CLIENT_ID,
    authorities: {
        signUpSignIn: {
            authority: process.env.REACT_APP_AZURE_SIGN_UP_SIGN_IN_AUTHORITY,
        }
    },
    authorityDomain: process.env.REACT_APP_AZURE_AUTHORITY_DOMAIN,
    redirectUri: process.env.REACT_APP_AZURE_REDIRECT_URI,
    scopes: [
        process.env.REACT_APP_AZURE_SCOPE,
    ],
}

export const b2cPolicies = Policies;

/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */

export const msalConfig = {
    auth: {
        clientId: b2cPolicies.clientId, // This is the ONLY mandatory field that you need to supply.
        authority: b2cPolicies.authorities.signUpSignIn.authority, // Choose SUSI as your default authority.
        knownAuthorities: [b2cPolicies.authorityDomain], // Mark your B2C tenant's domain as trusted.
        redirectUri: b2cPolicies.redirectUri, // You must register this URI on Azure Portal/App Registration. Defaults to window.location.origin
        postLogoutRedirectUri: "/", // Indicates the page to navigate after logout.
        navigateToLoginRequestUrl: false, // If "true", will navigate back to the original request location before processing the auth code response.
    },
    cache: {
        cacheLocation: process.env.REACT_APP_AZURE_CACHE_LOCATION, // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
        storeAuthStateInCookie: true, // Set this to "true" if you are having issues on IE11 or Edge
    },
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */

export const loginRequest = {
    scopes: b2cPolicies.scopes,
};

/**
 * Add here the endpoints and scopes when obtaining an access token for protected web APIs. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
// export const protectedResources = {
//     apiHello: {
//         endpoint: "http://localhost:5000/hello",
//         scopes: ["https://codelessonelocal.onmicrosoft.com/2311dff1-f3c3-4c52-bf0d-1f8098bdc3a9/access_as_user"], // e.g. api://xxxxxx/access_as_user
//     },
// }
